<template>
  <div class="modal modal-container modal-transaction fade" id="modalResponseStatus" tabindex="-1" role="dialog"
       aria-labelledby="modalResponseStatus" aria-hidden="true">
    <div class="modal-dialog modal-lg modal-dialog-centered modal-dialog-md" role="document">
      <div class="modal-content">
        <div class="modal-body">
          <button type="button" class="close" data-dismiss="modal" aria-label="Close">
            <span aria-hidden="true">&times;</span>
          </button>
          <div class="modal-header">
            <div class="modal-title">Увага! При спробі заявити/підписати полісу виникла помилка</div>
          </div>
          <div v-if="dataResponse" class="modal-container__content orders">
            <div class="scroll-content">
              <div class="row">
                <div class="col-lg-12 col-md-12 col-sm-12 col-12">
                  <div class="info-block"  v-html="'Відповідь від модуля страхової компанії: '+dataResponse">
                  </div>
                </div>
              </div>
            </div>
            <div class="row">
              <div v-if="errorType" class="col-12 col-md-3">
                <button type="button" class="btn btn-primary" @click="agreePrice">Згоден з ціною</button>
              </div>
              <div v-else class="col-3"></div>
              <div class="col-12 col-md-5">
                <button type="button" class="btn btn-orange" @click="goBack">Редагувати дані</button>
              </div>
              <div v-if="errorType" class="col-12 col-md-4">
                <button type="button" class="btn btn-outline-secondary" @click="goToSearchOffers">Пошук іншої пропозиції</button>
              </div>
              <div class="col-4"></div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
});

<script>
export default {
  props: ['dataResponse','dataProductType'],
  data: function () {
    return {
    }
  },
  computed:{
    errorType(){
      return this.dataResponse?.errorInfo?.errorType || null === 'black-list';
    },
  },
  methods: {
    agreePrice() {
      this.$emit('change-price', this.dataResponse.errorInfo.newPrice)
      $('#modalResponseStatus').modal('hide');
    },
    goBack(){
      if(this.dataProductType == 'osago') {
        window.location.href = '/order-step';
      }else if(this.dataProductType == 'greencard'){
        window.location.href = '/greencard-steps';
      }else if(this.dataProductType == 'tourism'){
        window.location.href = '/tourism-steps';
      }else{
        return;
      }
    },
    goToSearchOffers() {
      $('#modalResponseStatus').modal('hide');
      this.$router.push({name: 'search'})
    }
  }
}
</script>
<style>
.scroll-content{
  overflow: auto;
  overflow-x: hidden;
  max-height: 300px;
}
.modalResponseStatus{
  padding-right: 0;
}
button.close{
  padding: 10px;
  position: absolute;
  right: 0;
}
</style>
